import 'vue';
import './helpers.mjs';
import './config.mjs';
import { b as registerComponent } from './plugins-ba5e2464.mjs';
import './MatchMediaMixin-09b141ca.mjs';
import { s as script } from './Field-937b4591.mjs';
export { s as OField } from './Field-937b4591.mjs';

var index = {
    install(app) {
        registerComponent(app, script);
    }
};

export default index;
